function nullToEmpty(s: string | null | undefined): string {
    return s ? s : "";
}

/**
 * cyrb53 — a small, fast, well-distributed string hash rendered as base-36. Not
 * cryptographic; use only where a collision is low-stakes (e.g. cache keys,
 * change-detection fingerprints), never for security.
 */
function cyrb53(value: string): string {
    let h1 = 0xdeadbeef;
    let h2 = 0x41c6ce57;
    for (let i = 0; i < value.length; i++) {
        const ch = value.charCodeAt(i);
        h1 = Math.imul(h1 ^ ch, 2654435761);
        h2 = Math.imul(h2 ^ ch, 1597334677);
    }
    h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507);
    h1 ^= Math.imul(h2 ^ (h2 >>> 13), 3266489909);
    h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507);
    h2 ^= Math.imul(h1 ^ (h1 >>> 13), 3266489909);
    const combined = 4294967296 * (2097151 & h2) + (h1 >>> 0);
    return combined.toString(36);
}

export { nullToEmpty, cyrb53 };
